/* eslint-disable */
import { useState, useEffect, useCallback } from 'react';

import { Modal, Checkbox, Space, Button, message, Typography } from 'antd';

import { getError, getVendorAgreementClient, localStorageUtility } from '../../clientUtils';
import { logout } from '../../API_Utils/common';
import { useAuth0 } from '@auth0/auth0-react';

const { Text } = Typography;

const VendorAgreementModal = () => {
  const { isAuthenticated } = useAuth0();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [unsignedAgreement, setUnsignedAgreement] = useState({});

  const { agreementId, name, link, actions } = unsignedAgreement || {};
  const canAccept = !!actions?.includes('ACCEPT_AGREEMENT');
  const canCancel = !!actions?.includes('SKIP');

  const handleCheckbox = (e) => {
    setChecked(e.target.checked);
  };

  const showLogoutError = (error) => {
    message.loading(
      <Space direction="vertical">
        <Text> {error?.response?.data?.status?.statusMessage || error?.message}</Text>
        <Text>You&apos;ll get logged out in 5 seconds...</Text>
      </Space>
    );

    setTimeout(() => {
      logout();
    }, 5000);
  };

  const checkAgreementStatus = useCallback(async () => {
    try {
      if (!isAuthenticated) {
        return;
      }
      const response = await getVendorAgreementClient().vendorAgreementCheckGet();
      const data = response?.data?.data;
      const firstAgreement = data?.unsignedAgreements?.[0];
      setUnsignedAgreement(firstAgreement);
      if (!data?.allow && localStorageUtility.getItem('showAgreement') === 'yes') setIsOpen(true);
    } catch (error) {
      if (error?.response?.status === 403) {
        showLogoutError(error);
      } else {
        message.error(getError(error));
      }
    }
  }, []);

  useEffect(() => {
    checkAgreementStatus();
  }, [checkAgreementStatus, isAuthenticated]);

  const handleModalCancel = () => {
    if (canCancel) {
      localStorageUtility.setItem('showAgreement', 'no');
      setIsOpen(false);
      setChecked(false);
      checkAgreementStatus();
    }
  };

  const handleAgreementAccept = async () => {
    setIsLoading(true);
    try {
      const response = await getVendorAgreementClient().vendorAgreementAcceptPost(agreementId);
      setIsOpen(false);
      setUnsignedAgreement({});
      message.success(response?.data?.data);
      setChecked(false);
      checkAgreementStatus();
    } catch (error) {
      if (error?.response?.status === 403) {
        showLogoutError(error);
      } else {
        message.error(getError(error));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Space direction="vertical">
      {!!link && (
        <Modal
          closeIcon={canCancel}
          footer={[
            ...(canAccept
              ? [
                  <Space key="submit" className="w-100 center">
                    <Button
                      key="submit"
                      disabled={!checked}
                      loading={isLoading}
                      onClick={handleAgreementAccept}
                      type="primary">
                      Agree
                    </Button>
                  </Space>
                ]
              : [])
          ]}
          maskClosable={false}
          onCancel={handleModalCancel}
          open={isOpen}
          title={name}
          width={700}>
          <Space className="w-100 center" direction="vertical">
            {!!link && (
              <iframe
                height="500"
                src={`${link}#&toolbar=0&statusbar=0&messages=0&navpanes=0&scrollbar=0`}
                style={{ border: 'none' }}
                title="Agreement.pdf"
                width="700"
              />
            )}
            {!!canAccept && (
              <Checkbox checked={checked} onChange={handleCheckbox}>
                I agree to the terms & conditions
              </Checkbox>
            )}
          </Space>
        </Modal>
      )}
    </Space>
  );
};

export default VendorAgreementModal;
